import { render, staticRenderFns } from "./WebsiteDialogue.vue?vue&type=template&id=097d1bda&scoped=true&"
import script from "./WebsiteDialogue.vue?vue&type=script&lang=js&"
export * from "./WebsiteDialogue.vue?vue&type=script&lang=js&"
import style0 from "./WebsiteDialogue.vue?vue&type=style&index=0&id=097d1bda&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "097d1bda",
  null
  
)

export default component.exports